import elementService from "../../../js/common/ElementService";

export default new class ShareButtonsService {
    public init(): void {
        for (const shareButton of document.querySelectorAll<HTMLAnchorElement>(".js-share-social")) {
            shareButton.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                this.openShareWindow(shareButton);
            });
        }
    }

    private openShareWindow(shareButton: HTMLAnchorElement): void {
        const socialNetwork = elementService.elementData(shareButton, "social");

        const pageUrl = encodeURIComponent(document.URL);
        const pageTitle = encodeURIComponent(document.title);

        switch (socialNetwork) {
            case "facebook":
                this.openWindowByPattern(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}&t=${pageUrl}`);
                break;

            case "twitter":
                this.openWindowByPattern(`https://twitter.com/intent/tweet?text=${pageTitle}:%20${pageUrl}`);
                break;

            default:
                throw new Error(`Unknown social network: ${socialNetwork}.`);
        }
    }

    private openWindowByPattern(url: string): void {
        window.open(url, "_share", "width=600, height=450, menubar=no, toolbar=no, resizable=yes, scrollbars=yes");
    }
}();
